import { makeStyles } from '@material-ui/core';
import sauterLogo from '../../assets/sauter-logo-dark.png';

const useStyles = makeStyles({
  img: {
    height: 30,
    width: 'auto',
    filter: 'brightness(0) invert(1)', // Transform everything to pure white
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={sauterLogo} alt="Sauter" />;
};
